import { Link } from 'react-router-dom';
import { Twitter, Instagram, Facebook, Linkedin } from 'lucide-react';
import { FairdayLogo } from '../components/Brand/FairdayLogo';

export const Footer = () => {
  return (
    <footer className="border-t border-zinc-800/50 bg-zinc-900/30">
      {/* Main Footer Content */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Logo & Description */}
          <div className="col-span-2 md:col-span-1">
            <FairdayLogo className="h-8 w-auto mb-4" color="white" />
            <p className="text-sm text-zinc-500 leading-relaxed">
              Performance-based legal lead generation for law firms and advertisers.
            </p>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <a href="mailto:support@fairday.app" className="text-sm text-zinc-400 hover:text-accent transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="https://fairday.app" target="_blank" rel="noopener noreferrer" className="text-sm text-zinc-400 hover:text-accent transition-colors">
                  Consumer Site
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/advertiser-terms" className="text-sm text-zinc-400 hover:text-accent transition-colors">
                  Master Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/advertiser-terms#exhibit-a" className="text-sm text-zinc-400 hover:text-accent transition-colors">
                  Marketing Compliance (Exhibit A)
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/faq" className="text-sm text-zinc-400 hover:text-accent transition-colors">
                  Advertiser FAQ
                </Link>
              </li>
              <li>
                <Link to="/api" className="text-sm text-zinc-400 hover:text-accent transition-colors">
                  API Documentation
                </Link>
              </li>
              <li>
                <a href="mailto:advertiser-support@fairday.app" className="text-sm text-zinc-400 hover:text-accent transition-colors">
                  Advertiser Support
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-zinc-800/50">
        <div className="max-w-6xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-zinc-600">
              &copy; {new Date().getFullYear()} Fairday. All rights reserved.
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-4">
              <a href="#" className="text-zinc-600 hover:text-accent transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-zinc-600 hover:text-accent transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-zinc-600 hover:text-accent transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-zinc-600 hover:text-accent transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
